import { useModal } from "@/context/ModalContext";
import { TextArea } from "@jammable/ui-components/Forms";
import { Spinner } from "@jammable/ui-components/Loader";
import { Button, toast } from "@jammable/ui-core";
import axios from "axios";
import { getAuth } from "firebase/auth";
import { useFormik } from "formik";
import Image from "next/image";
import React, { useState } from "react";
import * as Yup from "yup";

const GenerateImageModal = ({ setLocalImage, setImage }) => {
  const validationSchema = Yup.object().shape({
    prompt: Yup.string().required("Prompt is required"),
  });
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const { closeModal } = useModal();

  const formik = useFormik({
    initialValues: {
      prompt: "",
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await axios.post(
          "/api/generate/generateImage",
          { prompt: values.prompt },
          { headers: { Authorization: token } },
        );
        setImages(response.data.result);
        setLoading(false);
        setLocalImage(response.data.result[0].url);
        setImage(response.data.result[0].url);
        closeModal("generate-image-modal");
      } catch (error) {
        setLoading(false);
        toast.error("Something went wrong... Please try again!");
      }
    },
  });
  const imageSize = 150;
  return (
    <div>
      <div className="tw-text-2xl tw-font-bold tw-text-center">
        Generate Image
      </div>
      <div className="tw-text-sm tw-text-center tw-text-black/50 tw-font-semibold">
        Describe the subject, style, and mood of the image you want to make. Be
        as detailed as possible!
      </div>
      <div className="tw-flex tw-w-full tw-justify-center tw-my-3 tw-flex-wrap tw-gap-4">
        {images.map((image) => (
          <Image
            className="tw-rounded-xl"
            width={imageSize}
            height={imageSize}
            src={image.url}
            alt="Generated"
          />
        ))}
      </div>
      <form
        onSubmit={formik.handleSubmit}
        className="tw-flex tw-flex-col tw-gap-4 tw-mt-4"
      >
        <TextArea
          placeholder="Describe the image you want to generate!"
          {...formik.getFieldProps("prompt")}
        />
        <Button
          type="submit"
          className="tw-w-full tw-rounded-full"
          disabled={loading}
        >
          {loading ? (
            <div className="tw-flex tw-items-center tw-gap-2">
              <Spinner size={4} className="tw-border-3 tw-border-white" />
              Generating...
            </div>
          ) : (
            "Generate"
          )}
        </Button>
      </form>
    </div>
  );
};

export default GenerateImageModal;
